module.exports = __webpack_public_path__ + "static/media/tjuv.7a982a7c.mp3";